import { ItemsBehavior, transactionApi } from '../../transactions.js';
import { AnyType } from './any.js';
const { free, aquire } = transactionApi;
export class AggregatedType extends AnyType {
    clone(value) {
        return value ? value.clone() : value;
    }
    toJSON(x, key, options) { return x && x.toJSON(options); }
    doInit(value, record, options) {
        const v = options.clone ? this.clone(value) : (value === void 0 ? this.defaultValue() : value);
        const x = this.transform(v, void 0, record, options);
        this.handleChange(x, void 0, record, options);
        return x;
    }
    doUpdate(value, record, options, nested) {
        const key = this.name, { attributes } = record;
        const prev = attributes[key];
        let update;
        if (update = this.canBeUpdated(prev, value, options)) {
            const nestedTransaction = prev._createTransaction(update, options);
            if (nestedTransaction) {
                if (nested) {
                    nested.push(nestedTransaction);
                }
                else {
                    nestedTransaction.commit(record);
                }
                if (this.propagateChanges)
                    return true;
            }
            return false;
        }
        const next = this.transform(value, prev, record, options);
        attributes[key] = next;
        if (this.isChanged(next, prev)) {
            this.handleChange(next, prev, record, options);
            return true;
        }
        return false;
    }
    canBeUpdated(prev, next, options) {
        if (prev && next != null) {
            if (next instanceof this.type) {
                if (options.merge)
                    return next.__inner_state__;
            }
            else {
                return next;
            }
        }
    }
    convert(next, prev, record, options) {
        if (next == null)
            return next;
        if (next instanceof this.type) {
            if (next._shared && !(next._shared & ItemsBehavior.persistent)) {
                this._log('error', 'Type-R:InvalidCollection', 'aggregated collection attribute is assigned with shared collection type', next, record, options.logger);
            }
            if (options.merge)
                return next.clone();
            if (next._owner) {
                this._log('warn', 'Type-R:InvalidOwner', 'object alreay has an owner and was cloned. Use explicit object.clone() to dismiss this warning.', next, record, options.logger);
                return next.clone();
            }
            return next;
        }
        return this.type.create(next, options);
    }
    dispose(record, value) {
        if (value) {
            this.handleChange(void 0, value, record, {});
        }
    }
    validate(record, value) {
        var error = value && value.validationError;
        if (error)
            return error;
    }
    create() {
        return this.type.create();
    }
    initialize(options) {
        options.changeHandlers.unshift(this._handleChange);
    }
    _handleChange(next, prev, record, options) {
        if (prev) {
            free(record, prev);
            options.unset || prev.dispose();
        }
        if (next)
            aquire(record, next, this.name);
    }
}
//# sourceMappingURL=owned.js.map